import { ReactElement } from 'react'
import { Box, Popover, Stack, Typography } from '@mui/material'
import PlanSettingsForm from '@editor/pages/Export/components/ExportSettingsForm/components/PlanSettingsForm'
import { StateIndicator } from '@ui/feedback'
import { useDebouncedPlanSettingsSave, useGetPlanSettings } from '@editorHooks'

interface Props {
  anchorEl: HTMLElement | null
  onClose: () => void
}

const PlanAreaSettingsPopover = ({ anchorEl, onClose }: Props): ReactElement => {
  const { data: planSettings } = useGetPlanSettings()
  const { onPlanSettingsChange, flushPlanSettings, stateIndicatorType } =
    useDebouncedPlanSettingsSave()

  const handleClose = () => {
    flushPlanSettings()
    onClose()
  }

  return (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={handleClose}
      disablePortal
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      slotProps={{
        paper: {
          sx: theme => ({
            p: 1.5,
            maxWidth: 520,
            bgcolor: theme.palette.background.paper,
            backgroundImage: 'none',
          }),
        },
      }}
      data-cy="plan-area-settings-popover"
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 1 }}>
        <Typography variant="subtitle2">Planbereich</Typography>
        <StateIndicator type={stateIndicatorType} onSave={flushPlanSettings} />
      </Stack>
      {planSettings ? (
        <Box sx={{ minWidth: 360 }}>
          <PlanSettingsForm
            planSettings={planSettings}
            onPlanSettingsChange={onPlanSettingsChange}
            formId="plan-area-settings-form"
          />
        </Box>
      ) : null}
    </Popover>
  )
}

export default PlanAreaSettingsPopover
